import * as constants from '../constants.js'
import notifications from "../notifications"

export default {
    OnSuccess(description){
        notifications.Success('Mensagens', description);
    },

    OnError(resp, description){
        notifications.Error('Mensagens', description);
    },
    
    OnWarning(description) {
        notifications.Warning("Contactar", description);
    },

    OnUnauthorized(){
        window.location.reload();
    },

    GetLeads: async function(size, pageNum, orderDirection, searchTerm, status, filter, orderBy ){
        let reqUriParams = `orderDirection=${orderDirection}`;
        if (pageNum != '') {
            reqUriParams += `&PageNum=${pageNum}`;
        }
        if (size != '') {
            reqUriParams += `&PageSize=${size}`;
        }
        if (searchTerm !== '') {
            reqUriParams += `&Filter.SearchTerm=${encodeURI(searchTerm)}`;
        }
        if (status != null) {
            reqUriParams += `&status=${status}`;
        }
        if (orderBy != "" && orderBy != undefined) {
            reqUriParams += `&OrderBy=${orderBy}`;
        }
        if (filter != null) {
            if (filter.FilterBy != null) {
                reqUriParams += `&Filter.FilterBy=${filter.FilterBy}`;
            }
            var IdAppUser = new URL(location.href).searchParams.get("IdAppUser")
            if (IdAppUser != null) {
                reqUriParams += `&Filter.IdBuyer=${IdAppUser}`;
            }
            var IdAd = new URL(location.href).searchParams.get("IdAd")

            if (IdAd != null) {
                reqUriParams += `&Filter.IdAd=${IdAd}`;
            }
        }

        let result = await fetch(`${constants.API_ENDPOINT_LEADS}?${reqUriParams}`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao pesquisar as Mensagens");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

    GetLead: async function (idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao carregar a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

    GetLeadsMessages: async function(idLead, pageNum, size){
        let reqUriParams = ``;
        if (pageNum != '') {
            reqUriParams += `&PageNum=${pageNum}`;
        }
        if (size != '') {
            reqUriParams += `&PageSize=${size}`;
        }

        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idLead}/messages?${reqUriParams}`, {
            method: constants.HTTP_METHOD_GET
        }).then(resp => {
            
            if (!resp.ok) {
                if (resp.status == 500) {
                    this.OnError(resp, "Ocorreu uma anomalia ao pesquisar as Mensagens");
                    return null;
                }
                if(resp.status == 401){
                    this.OnUnauthorized();
                    return null;
                }
            }

            return resp.json();
        });
        
        return result;
    },

    SetUserMessagesAsRead: async function (idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/usr-readed`, {
            method: constants.HTTP_METHOD_PUT,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idlead)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao ler a Mensagem do utilizador");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

    ArchiveLead: async function(idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/archive`, {
            method: constants.HTTP_METHOD_POST,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idlead)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao arquivar a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Mensagem arquivada com sucesso");
                    }
                }

                return resp.json();
            });

        return result;
    },
    UnarchiveLead: async function(idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/unarchive`, {
            method: constants.HTTP_METHOD_POST,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idlead)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao desarquivar a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Mensagem desarquivada com sucesso");
                    }
                }

                return resp.json();
            });

        return result;
    },
    DeleteLead: async function (idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/`, {
            method: constants.HTTP_METHOD_DELETE,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idlead)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao remover a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Mensagem eliminada com sucesso");
                    }
                }

                return resp.json();
            });

        return result;
    },
    CreateLeadMessage: async function (idLead, formData) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idLead}/messages`, {
            method: constants.HTTP_METHOD_POST,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(formData)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao criar a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },
    SetMessagesAsRead: async function (idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/usr-readed`, {
            method: constants.HTTP_METHOD_PUT,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idlead)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao ler a Mensagem do utilizador");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },
    ArchiveLeads: async function(idleads) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/archive`, {
            method: constants.HTTP_METHOD_POST,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idleads)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao arquivar a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Mensagens arquivadas com sucesso");
                    }
                }

                return resp.json();
            });

        return result;
    },
    UnarchiveLeads: async function(idleads) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/unarchive`, {
            method: constants.HTTP_METHOD_POST,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idleads)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao desarquivar a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Mensagens desarquivadas com sucesso");
                    }
                }

                return resp.json();
            });

        return result;
    },
    DeleteLeads: async function(idleads) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/`, {
            method: constants.HTTP_METHOD_DELETE,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idleads)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao arquivar a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Mensagens arquivadas com sucesso");
                    }
                }

                return resp.json();
            });

        return result;
    },
    CreateLeadFromAd: async function(formData){
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/ad`, {
            method: constants.HTTP_METHOD_POST,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(formData)
        })
            .then(async resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao criar o contacto");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                    if (resp.status == 429) {
                        this.OnWarning("Detectamos uma quantidade muito elevada de pedidos. Aguarde e tente novamente.");
                    }
                }
                return resp.json();
            });

        return result;
    }
}

